var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "122.879px",
    height: "66.975px",
    viewBox: "0 0 122.879 66.975",
    enableBackground: "new 0 0 122.879 66.975",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.577,0h107.726c4.168,0,7.576,3.419,7.576,7.578v51.82 c0,4.158-3.418,7.577-7.576,7.577H7.577C3.419,66.975,0,63.564,0,59.397V7.578C0,3.41,3.41,0,7.577,0L7.577,0z M32.558,14.489 v30.406h6.3v7.59H22.092V14.489H32.558L32.558,14.489z M51.88,14.489v37.996H41.415V14.489H51.88L51.88,14.489z M80.848,14.489 l-5.293,37.996H59.73l-6.063-37.996h11.024c1.244,10.479,2.15,19.342,2.719,26.587c0.559-7.325,1.135-13.826,1.719-19.502 l0.693-7.085H80.848L80.848,14.489z M82.65,14.489h17.426v7.589h-6.959v7.253h6.502v7.205h-6.502v8.358h7.67v7.59H82.65V14.489 L82.65,14.489z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.56be359197154666f58bab830825e431.svg";
export { ForwardRef as ReactComponent };